import React, { ChangeEvent, FC } from 'react';
import { FormControl, FormControlLabel, FormHelperText, FormLabel, Radio, RadioGroup } from '@material-ui/core';
import { createUseStyles } from 'src/theming';

const useStyles = createUseStyles({
  root: {
    flexDirection: 'row !important',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    '& > :first-child': {
      marginRight: 16,
    },
    '& label': {
      marginBottom: 0,
    },
  },
  helperText: {
    marginTop: '-15px !important',
    width: '100%',
  },
});

interface Props {
  label: string;
  value?: string;
  error?: boolean;
  helperText?: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

const YesNoField: FC<Props> = React.forwardRef<any, Props>((props, ref) => {
  const { label, value, onChange, error, helperText } = props;
  const classes = useStyles();

  return (
    <FormControl fullWidth error={error} className={classes.root}>
      <FormLabel>{label}</FormLabel>
      <RadioGroup row value={`${value}`} onChange={onChange}>
        <FormControlLabel value='true' control={<Radio />} label='Oui' />
        <FormControlLabel value='false' control={<Radio />} label='Non' />
      </RadioGroup>

      {helperText && <FormHelperText className={classes.helperText}>{helperText}</FormHelperText>}
    </FormControl>
  );
});

export default YesNoField;
